module.exports = __webpack_public_path__ + "static/media/map@2x.d9976be3.png";